import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import LanguageStore from "../../store/LanguageStore";

const VideoStatistics = observer(({viewCount, likeCount, commentCount, videoId}) => {
    const t = LanguageStore.t;

    const formatNumber = (num) => {
        if (!num && num !== 0) return '0';
        
        const number = typeof num === 'string' ? parseInt(num, 10) : num;
        
        if (number >= 1000000) {
            // Миллионы
            const millions = number / 1000000;
            return millions % 1 === 0 
                ? `${millions}M` 
                : `${millions.toFixed(1)}M`;
        } else if (number >= 1000) {
            // Тысячи
            const thousands = number / 1000;
            return thousands % 1 === 0 
                ? `${thousands}K` 
                : `${thousands.toFixed(1)}K`;
        }
        
        return number.toString();
    };

    const items = [
        {
            title: t('views'),
            icon: 'remove_red_eye',
            value: formatNumber(viewCount)
        },
        {
            title: t('likes'),
            icon: 'thumb_up_alt',
            value: formatNumber(likeCount)
        },
        {
            title: t('comments'),
            icon: 'comment',
            value: formatNumber(commentCount)
        }
    ];

    return (
        <div className="video-statistics">
            {items.map((element, index) => {
                return (
                    <div key={index} className="video-statistics__item" title={element.title}>
                        <i className="material-icons video-statistics__icon">{element.icon}</i>
                        <div className="video-statistics__value">{element.value}</div>
                    </div>
                )
            })}
            {videoId && (
                <Link 
                    to={`/video/${videoId}`} 
                    className="video-statistics__item video-statistics__item--analytics" 
                    title={t('analytics') || 'Analytics'}
                >
                    <span className="video-statistics__emoji">📈</span>
                </Link>
            )}
        </div>
    )
});

export default VideoStatistics;